import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { FileTypeSelectOption } from "../components/field-components/file-type-select/file-type-select.component";
import { inject } from "@angular/core";
import { FieldFilterService } from "../services/filters/field-filter.service";
import { OrgMapsFileTypesResult } from "../models/org-maps-file-types-result";
import { firstValueFrom } from 'rxjs';

type FileTypeFilterState = {
  fileTypeOptions: FileTypeSelectOption[];
};

const initialState: FileTypeFilterState = {
  fileTypeOptions: [],
};

export const FileTypeFilterStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, filterService = inject(FieldFilterService)) => ({
    setFileTypeOptions(options: FileTypeSelectOption[]) {
      patchState(store, { fileTypeOptions: options });
    },
    async getMapFileTypesByPayerId(payerId: number | number[] | null): Promise<void> {
        if (
            payerId === null || 
            payerId === undefined ||
            (Array.isArray(payerId) && payerId.length === 0)
        ) {
            patchState(store, { fileTypeOptions: [] });
            return;
        }
    
        const param = Array.isArray(payerId) ? payerId.join(',') : String(payerId);
    
        if (!param || param === '0') {
            patchState(store, { fileTypeOptions: [] });
            return;
        }
    
        try {
            const results: OrgMapsFileTypesResult[] =
                await firstValueFrom(filterService.getMapFileTypesByPayerId(param));
    
            const options: FileTypeSelectOption[] = results.map(result => ({
                label: result.FileType,
                value: result.ID,
                selected: false,
            }));
    
            patchState(store, { fileTypeOptions: options });
        } catch (err) {
            console.error('Error fetching file types:', err);
            patchState(store, { fileTypeOptions: [] });
        }
    },      
  }))
);
